import {
    ApodisCoinPurchasable,
    ApodisCoinPurchaseApiResponse,
    ApodisCoinTransaction
} from "@/core/interfaces/ApodisCoin";
import {PaginatedData, PaginationRequest} from "@/core/interfaces/api";

export default function (apiClient) {
    return {
        /**
         * Get apodis coin balance for current organization.
         */
        balance(): Promise<{ balance: number }> {
            return apiClient.get("apodis-coins")
                .then(response => response.data.data);
        },
        /**
         * Get apodis coin store.
         */
        store(): Promise<ApodisCoinPurchasable[]> {
            return apiClient.get("apodis-coins/store")
                .then(response => response.data.data);
        },
        /**
         * Purchase an Apodis coin purchasable product.
         */
        purchase(purchasable_id: number, purchasable_type: string): Promise<ApodisCoinPurchaseApiResponse> {
            const data = {purchasable_id, purchasable_type};

            return apiClient.post(`apodis-coins/purchase`, {data})
                .then(response => response.data);
        },
        /**
         * Transactions history of Apodis coin.
         */
        async transactions(params: PaginationRequest): Promise<PaginatedData<ApodisCoinTransaction[]>> {
            return apiClient.get("apodis-coins/transactions", params)
                .then(response => response.data);
        }
    };
}
